import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "occupancy-calendar"
};
var _hoisted_2 = {
  class: "customized-header d-flex flex-row fl-s-b"
};
var _hoisted_3 = {
  class: "header-title d-flex fl-col fl-j-c"
};
var _hoisted_4 = {
  class: "customized-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_smeetz_calendars = _resolveComponent("smeetz-calendars");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.dialogVisible = $event;
    }),
    "close-on-click-modal": true,
    "close-on-press-escape": true,
    "show-close": false,
    fullscreen: true
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("occupancy-calendar.dialog-header")), 1)]), _createElementVNode("div", {
        class: "close-button d-flex fl-col fl-j-c",
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.close && _ctx.close.apply(_ctx, arguments);
        })
      }, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.closeIconContent,
        iconAlt: _ctx.closeIconAlt,
        iconStyle: _ctx.closeIconStyle
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"])])]), _createElementVNode("div", _hoisted_4, [_ctx.showCalendar && _ctx.dialogVisible ? (_openBlock(), _createBlock(_component_smeetz_calendars, {
        key: 0,
        userId: _ctx.getUserId,
        userGraphqlToken: _ctx.getUserGraphqlToken,
        userTableKey: _ctx.getOccupancyTableKey,
        userToken: _ctx.getUserToken,
        groupId: String(_ctx.getGroupId),
        env: _ctx.env,
        lang: _ctx.getLanguage(),
        filters: [{
          key: 'group_access',
          option: 12,
          value: String(_ctx.getGroupId)
        }],
        height: "100vh",
        appType: "pos",
        "onEditButton:clicked": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.onCalendar($event, 'edit-button:clicked');
        })
      }, null, 8, ["userId", "userGraphqlToken", "userTableKey", "userToken", "groupId", "env", "lang", "filters"])) : _createCommentVNode("", true)])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}